import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { activeState } from "../../theme/activeState";
import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";
import { groupStyle } from "../Group/Group.css";
import { responsiveCard } from "../../utils/responsive";
import { alignVariants } from "../../utils/vanilla/alignVariants";

export const iconButtonStyle = recipe({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: theme.colors.onBackground,
    transition: transition(
      "color",
      "outline",
      "background-color",
      "border-color",
      "border-radius",
      "transform",
    ),
    userSelect: "none",
    position: "relative",
    selectors: {
      "&:not([disabled])": {
        cursor: "pointer",
      },
      "&:not([disabled]):active": {
        ...activeState,
      },
      "&[disabled]": {
        ...disabledState,
      },

      [`${groupStyle}[data-direction="vertical"] &:first-of-type`]: {
        borderBottomRightRadius: "0",
        borderBottomLeftRadius: "0",
      },
      [`${groupStyle}[data-direction="vertical"] &:last-of-type`]: {
        borderTopLeftRadius: "0",
        borderTopRightRadius: "0",
      },
      [`${groupStyle}[data-direction="vertical"] &:not(:first-of-type)`]: {
        marginTop: "-1px",
      },

      [`${groupStyle}[data-direction="horizontal"] &:first-of-type`]: {
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
      },
      [`${groupStyle}[data-direction="horizontal"] &:last-of-type`]: {
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
      },
      [`${groupStyle}[data-direction="horizontal"] &:not(:first-of-type)`]: {
        marginLeft: "-1px",
      },
    },
  },
  variants: {
    alignSelf: alignVariants("alignSelf"),
    size: {
      xxs2: {
        width: rem(22),
        height: rem(22),
        borderRadius: theme.borderRadiuses.xxs,
      },
      xxs: {
        width: rem(28),
        height: rem(28),
        borderRadius: theme.borderRadiuses.xs2,
      },
      xs: {
        width: rem(36),
        height: rem(36),
        borderRadius: theme.borderRadiuses.xs2,
      },
      s: {
        width: rem(48),
        height: rem(48),
        borderRadius: theme.borderRadiuses.s,
      },
      m: {
        width: rem(56),
        height: rem(56),
        borderRadius: theme.borderRadiuses.s,
      },
      l: {
        width: rem(64),
        height: rem(64),
        borderRadius: theme.borderRadiuses.s,
      },
      header: {
        width: rem(42),
        height: rem(42),
        borderRadius: theme.borderRadiuses.s,
      },
      inline: {
        width: rem(32),
        height: rem(32),
        borderRadius: theme.borderRadiuses.s,
        ...responsiveCard({
          500: {
            width: rem(42),
            height: rem(42),
          },
        }),
      },
    },
    rounded: {
      true: {
        borderRadius: "50%",
      },
    },
  },
  defaultVariants: {
    size: "s",
  },
});

export const iconStyle = style({
  zIndex: 2,
});

export const inlineSizedIconStyle = style({
  width: rem(16),
  height: rem(16),
  ...responsiveCard({
    500: {
      width: rem(20),
      height: rem(20),
    },
  }),
});
